import React from 'react';

export type IWebpageContent = {
  children?: JSX.Element;
};

export const WebpageContent = (props: IWebpageContent): JSX.Element => {
  const { children } = props;

  return (
    <div className="w-screen h-screen bg-gray-100 select-none grid grid-cols-12 gap-2">
      <div className="col-start-2 col-span-4 flex flex-col my-auto justify-items-center">{children}</div>
    </div>
  );
};
